import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    api
      .post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        window.history.replaceState(null, "", window.location.pathname);
        // linked=true: l'utente era gia' loggato e Google e' stato collegato al suo account
        if (data?.linked) {
          navigate("/profilo?social=linked_google", { replace: true });
        } else {
          navigate("/?auth=ok", { replace: true });
        }
      })
      .catch((err) => {
        window.history.replaceState(null, "", window.location.pathname);
        if (err?.response?.status === 409) {
          navigate("/profilo?social=clash_google", { replace: true });
        } else {
          navigate("/?auth=denied", { replace: true });
        }
      });
  }, [location.hash, navigate]);

  return (
    <main className="pt-40 pb-40 flex items-center justify-center">
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-steel animate-blink" data-testid="auth-callback-loading">
        Accesso in corso…
      </p>
    </main>
  );
}
